import { render, staticRenderFns } from "./summariesAndConclusionsTable.vue?vue&type=template&id=6c9df9d3"
import script from "./summariesAndConclusionsTable.vue?vue&type=script&lang=js"
export * from "./summariesAndConclusionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports